import React from 'react';
import VirtualList from 'react-tiny-virtual-list';
import styled from 'styled-components';

export const DefaultVirtualListItemHeight = 44;

const StyledLi = styled('li')`
  list-style: none;
`;

const PlaceholderStyled = styled('li')`
  list-style: none;
  margin-top: 12px;
  color: #9a9a9a;
  text-align: center;
`;

export default class CustomMenuList extends React.Component {
  renderItem = props => {
    const { children } = this.props as any;
    if (Array.isArray(children)) {
      return (
        <StyledLi style={props.style} key={props.index} title={children[props?.index]?.props?.data?.value}>
          {children[props.index]}
        </StyledLi>
      );
    }
    return <PlaceholderStyled key={props.index}>{children.props.children}</PlaceholderStyled>;
  };

  render() {
    const { options, children, maxHeight, getValue } = this.props as any;

    const [value] = getValue();

    const childrenOptions = React.Children.toArray(children);
    const isContentFitContainer = maxHeight > childrenOptions.length * DefaultVirtualListItemHeight;

    const wrapperHeight = isContentFitContainer ? childrenOptions.length * DefaultVirtualListItemHeight : maxHeight;
    const offsetMultiplier = isContentFitContainer ? -1 : options.indexOf(value);
    const initialOffset = offsetMultiplier * DefaultVirtualListItemHeight;

    return (
      <span className="react-virtualized-list-wrapper">
        <VirtualList
          width="100%"
          height={wrapperHeight + 6}
          scrollOffset={initialOffset}
          itemCount={childrenOptions.length}
          itemSize={DefaultVirtualListItemHeight}
          renderItem={this.renderItem}
        />
      </span>
    );
  }
}
